import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * Active workspace user 一覧フック
 *
 * pipeline-permissions 画面の UserChipPicker が候補表示に使う。
 * Admin API 側でも短時間 cache されており、頻繁に refetch されない想定。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business workspace user 一覧をキャッシュ付きで取得するフック
 * @graph-connects usersApi [calls] users.list oRPC procedure
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useWorkspaceUsers() {
  return useQuery({
    queryKey: queryKeys.workspaceUsers.list(),
    queryFn: usersApi.list,
    // workspace の名簿は頻繁に変わらないので 5 分 stale 許容
    staleTime: 5 * 60 * 1000,
  });
}
